import "./_style.scss";

import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { dateHourToBr } from "../../../../util/date";

const ListPendencias = ({ documentos }) => {
  return documentos.map((item, index) => (
    <div className="content-pendencias__item" key={index}>
      <p>
        <span className="font-weight-bold">Data/hora do envio do doc: </span>{" "}
        {dateHourToBr(item.DataCaptura)}
      </p>
      <p>
        <span className="font-weight-bold">Nome do documento: </span>
        {item.GrupoDocumental}
      </p>
      <p>
        <span className="font-weight-bold">Análise:</span>{' '}{item.Criterio}
      </p>
      <p>
        <span className="font-weight-bold">Análise conforme as regras? </span>{' '}{item.Resposta}</p>
      <ul>
        {item.Motivo && (
          <li><span className="font-weight-bold">Motivo:</span>{' '}{item.Motivo}</li>
        )}
        {(item.RespostaObservacao || item.MotivoObservacao) && (
          <li><span className="font-weight-bold">Observação:</span>{' '}
            {item.RespostaObservacao && (<span>{item.RespostaObservacao}</span>)}
            <br />
            {item.MotivoObservacao && (<span>{item.MotivoObservacao}</span>)}
          </li>
        )}
      </ul>
    </div>
  ));
};

const ModalDocumentosPendentes = ({ isOpen, toggle, contrato }) => {
  return (
    <Modal
      toggle={toggle}
      isOpen={isOpen}
      className="modal-default modal-lg modal-pendencias"
    >
      <ModalHeader>
        Pendência(s) no(s) documento(s) abaixo do contrato:{" "}
        {contrato ? contrato.NumeroContrato : 0}
      </ModalHeader>
      <ModalBody>
        <div className="content-pendencias mb-3">
          <ListPendencias documentos={contrato.documentos} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="btn_danger" onClick={toggle}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalDocumentosPendentes;
